module.exports = __webpack_public_path__ + "img/softrate.125d9080.png";